export default {
  networks: [],
  networkOverviewGraphs: {},
  networkPlayerGraphs: {},
  networkSubUsers: {},
  networkFirewallEntries: {},
  networkASNEntries: {},
  networkCountryEntries: {},
  activeNetwork: null
};
